import * as React from "react";
type Props = {
  className?: string,
};
function SvgNever({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-never"
      className={className}
    >
      <path
        d="M14 27.8418C21.5059 27.8418 27.7129 21.6348 27.7129 14.1289C27.7129 6.60938 21.5059 0.416016 13.9863 0.416016C6.48047 0.416016 0.287109 6.60938 0.287109 14.1289C0.287109 21.6348 6.49414 27.8418 14 27.8418ZM14 26.0645C7.38281 26.0645 2.06445 20.7324 2.06445 14.1289C2.06445 7.51172 7.38281 2.17969 13.9863 2.17969C20.6035 2.17969 25.9355 7.51172 25.9492 14.1289C25.9492 20.7324 20.6172 26.0645 14 26.0645ZM9.22852 19.7754C9.47461 19.7754 9.67969 19.6797 9.85742 19.502L13.9863 15.3594L18.1426 19.502C18.3203 19.6797 18.5254 19.7754 18.7715 19.7754C19.25 19.7754 19.6328 19.3926 19.6328 18.9141C19.6328 18.668 19.5371 18.4766 19.3594 18.2988L15.2031 14.1426L19.373 9.97266C19.5645 9.78125 19.6328 9.60352 19.6328 9.35742C19.6328 8.89258 19.25 8.50977 18.7715 8.50977C18.5527 8.50977 18.3613 8.5918 18.1699 8.79688L13.9863 12.9395L9.84375 8.79688C9.66602 8.61914 9.47461 8.53711 9.22852 8.53711C8.75 8.53711 8.36719 8.89258 8.36719 9.37109C8.36719 9.60352 8.44922 9.80859 8.62695 9.98633L12.7832 14.1426L8.62695 18.3125C8.44922 18.4766 8.36719 18.6816 8.36719 18.9141C8.36719 19.3926 8.75 19.7754 9.22852 19.7754Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgNever;
